export default {
  // Societies
  ADD_SOCIETY: 'Añadir Sociedad',
  ADD_SOCIETY_AI: 'Añadir Sociedad - IA',
  ADD_SOCIETY_AI_CONSTITUTION: 'Añadir Sociedad - Constitución - IA ',
  ADD_SOCIETY_WIZARD: 'Añadir Sociedad - Wizard',
  UPDATE_SOCIETY: 'Actualizar Sociedad',
  DELETE_SOCIETY: 'Eliminar Sociedad',
  DELETE_SOCIETY_VALUE: 'Eliminar Valor Sociedad',

  // Operations
  ADD_PARTNER: 'Añadir Socio',
  ADD_PARTNERS: 'Añadir Socios XLS',
  ADD_PARTNER_EMBEDDED: 'Añadir Socio Embebido',
  ADD_BENEFICIARY: 'Añadir Beneficiario',
  ROLLBACK_OPERATION: 'Deshacer Operación',
  INVITE_PARTNER_DETAIL: 'Invitar Ficha Socio',

  CONSTITUTION: 'Operación Constitución',
  CAPITAL_INCREASE: 'Operación Ampliación',
  CAPITAL_DECREASE: 'Operación Reducción',
  SELL_PARTICIPATION: 'Operación Compra / Venta',
  HERITAGE: 'Operación Herencia',
  DONATION: 'Operación Donación',
  SPLIT: 'Operación Split',
  RENUMERATION: 'Operación Renumeración',
  RECLASSIFICATION: 'Operación Reclasificación',
  DIVIDENDS_DISTRIBUTION: 'Operación Reparto de Dividendos',

  // Plans
  STOCK_OPTION: 'Añadir Plan Stock Options',
  PHANTOM_SHARES: 'Añadir Plan Phantom Shares',
  WARRANT: 'Añadir Plan Warrant',

  // Tender Offers
  ADD_TENDER_OFFER: 'Añadir Oferta de Compra',
  EDIT_TENDER_OFFER: 'Editar Oferta de Compra',

  // Boards
  ADD_BOARD: 'Añadir Junta',
  ADD_BASIC_BOARD: 'Añadir Junta Básica',
  EDIT_BOARD: 'Editar Junta',
  ASSIST_BOARD: 'Asistente Junta',
  DELETE_BOARD: 'Eliminar Junta',
  DUPLICATE_BOARD: 'Duplicar Junta',

  // Employees Plans
  ADD_EMPLOYEES_PLAN: 'Añadir Plan de Empleados',
  EDIT_EMPLOYEES_PLAN: 'Editar Plan de Empleados',

  // Drafts
  SELL_PARTICIPATION_DRAFT: 'Borrador Compra / Venta',

  // Notifications
  VESTING_UNITS_NOTIFICATION: 'Notificación de Unidades Vesteadas',

  // Partner Representants
  ADD_PARTNER_REPRESENTANT: 'Añadir Representante Socio',
  DELETE_PARTNER_REPRESENTANT: 'Eliminar Representante Socio',

  // Guests
  ADD_GUEST: 'Añadir Invitado',
  DELETE_GUEST: 'Eliminar Invitado',

  // Councils
  ADD_COUNCIL: 'Añadir Consejo',
  EDIT_COUNCIL: 'Editar Consejo',
  DELETE_COUNCIL: 'Eliminar Consejo',
  DUPPLICATE_COUNCIL: 'Duplicar Consejo',
};
